import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { AgentBuilderRunEvent } from '../../../core/api/generated/models/AgentBuilderRunEvent';
import { SocketClientService } from '../../../core/realtime/socket-client.service';

const AGENT_BUILDER_SOCKET_EVENT = 'agent-builder:event';
const AGENT_BUILDER_SUBSCRIBE_EVENT = 'agent-builder:subscribe';
const AGENT_BUILDER_UNSUBSCRIBE_EVENT = 'agent-builder:unsubscribe';

@Injectable({ providedIn: 'root' })
export class AgentMissionRealtimeService {
  private readonly socket = inject(SocketClientService);

  events(): Observable<AgentBuilderRunEvent> {
    this.socket.connect();
    return this.socket.on<AgentBuilderRunEvent>(AGENT_BUILDER_SOCKET_EVENT);
  }

  subscribe(runId: string): void {
    this.socket.connect();
    this.socket.emit(AGENT_BUILDER_SUBSCRIBE_EVENT, { runId });
  }

  unsubscribe(runId: string): void {
    this.socket.emit(AGENT_BUILDER_UNSUBSCRIBE_EVENT, { runId });
  }
}

